import {DATA_TYPES, VIEW_TYPES} from "./fieldTypes";

export const EVENT_FIELDS = [
    {
        name: "name",
        key: "eventType",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Event Type",
        modes: [],
        selfEditable: false,
    },
    {
        name: "name",
        key: "eventProductType",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Event Product Type",
        modes: [],
        selfEditable: false,
    },
    {
        name: "indoor",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "Indoor",
        modes: [],
        selfEditable: false,
    },
    {
        name: "golfProFirstName",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Golf Pro First Name",
        modes: [],
        selfEditable: false,
    },
    {
        name: "golfProLastName",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Golf Pro Last Name",
        modes: [],
        selfEditable: false,
    },
    {
        name: "golfProEmail",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Golf Pro Email",
        modes: [],
        selfEditable: false,
    },
    {
        name: "scheduledStart",
        dataType: DATA_TYPES.TIMESTAMP,
        viewType: VIEW_TYPES.TEXT,
        label: "Scheduled Start",
        modes: [],
        editableByRepTypeIds: [],
        selfEditable: false,
    },
    {
        name: "scheduledEnd",
        dataType: DATA_TYPES.TIMESTAMP,
        viewType: VIEW_TYPES.TEXT,
        label: "Scheduled End",
        modes: [],
        editableByRepTypeIds: [],
        selfEditable: false,
    },
    {
        name: "name",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Name",
        modes: [],
        selfEditable: false,
    },
    {
        name: "address1",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Address 1",
        modes: [],
        selfEditable: false,
    },
    {
        name: "address2",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Address 2",
        modes: [],
        selfEditable: false,
    },
    {
        name: "city",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "City",
        modes: [],
        selfEditable: false,
    },
    {
        name: "sate",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "State",
        modes: [],
        selfEditable: false,
    },
    {
        name: "postalCode",
        key: "location",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Postal Code",
        modes: [],
        selfEditable: false,
    },
    {
        name: "name",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Name",
        modes: [],
        selfEditable: false,
    },
    {
        name: "address1",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Address 1",
        modes: [],
        selfEditable: false,
    },
    {
        name: "address2",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Address 2",
        modes: [],
        selfEditable: false,
    },
    {
        name: "city",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "City",
        modes: [],
        selfEditable: false,
    },
    {
        name: "state",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "State",
        modes: [],
        selfEditable: false,
    },
    {
        name: "postalCode",
        key: "shipto",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Postal Code",
        modes: [],
        selfEditable: false,
    },

    {
        name: "fitterCount",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Fitter Count",
        modes: [],
        selfEditable: false,
    },
    {
        name: "name",
        key: "onsiteBuildStation",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Build Station",
        modes: [],
        selfEditable: false,
    },
    {
        name: "shareLink",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Share Link",
        modes: [],
        selfEditable: false,
    },
    {
        name: "businessUnitCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Business Unit",
        modes: [],
        selfEditable: false,
    },
    {
        name: "active",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "Active",
        modes: [],
        selfEditable: false,
    },
    {
        name: "languageCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Language",
        modes: [],
        selfEditable: false,
    },
    {
        name: "currencyCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Currency Code",
        modes: [],
        selfEditable: false,
    },
    {
        name: "bookabilityLevelName",
        key: "bookabilityLevel",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "BookAbility Level",
        modes: [],
        selfEditable: false,
    },
    {
        name: "name",
        key: "specsVisibility",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Specs Visibility",
        modes: [],
        selfEditable: false,
    },
];
